import useSite from '~/client/hooks/useSite';

type Props = {
  status: TournamentStatus;
  won?: boolean;
};

const useBadgeInfo = ({ status, won }: Props) => {
  const { isBitcasino } = useSite();
  if (status === 'current') {
    return { translate: 'general.active', bgColor: 'bg-roshi' };
  }
  if (status === 'future') {
    return {
      translate: 'game-leaderboard.coming-soon',
      bgColor: isBitcasino ? 'bg-frieza' : 'bg-piccolo',
    };
  }
  if (status === 'past' && won) {
    return {
      translate: 'game-leaderboards.winner',
      bgColor: 'bg-krillin',
    };
  }
  return {
    translate: 'gameleaderboard.past',
    bgColor: 'bg-popo',
  };
};

export default useBadgeInfo;
